import { ConnectionService } from './../services/connection/connection.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Connection } from '../models/connection';
import { AppAlertService } from '../services/app-alert/app-alert.service';
import { Person } from '../models/person';

@Component({
  selector: 'app-connection-form',
  templateUrl: './connection-form.component.html',
  styleUrls: ['./connection-form.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,

})
export class ConnectionFormComponent implements OnInit {

  @Input('connection') connection: Connection;
  @Input('person') person: Person;
  @ViewChild('item') accordion;


  qualityButtons = [
    {
      name: "N/A",
      value: "none"
    },
    {
      name: "Poor",
      value: "bad"
    },
    {
      name: "Okay",
      value: "okay"
    },
    {
      name: "Good",
      value: "good"
    },
    {
      name: "Great",
      value: "great"
    },
  ]

  initiatorButtons = [
    {
      name: "N/A",
      value: "none"
    },
    {
      name: "I did",
      value: "me"
    },
    {
      name: "They did",
      value: "them"
    }
  ]

  mediumButtons = [
    {
      name: "Text",
      value: "message"
    },
    {
      name: "Call",
      value: "call"
    },
    {
      name: "IRL",
      value: "irl"
    },
  ]

  setValue = {
    quality: null,
    initiator: null,
    medium: null,
    date: null
  }

  multiSelectGroupValue = [];

  dateButtons = [
    {
      name: "Another Day",
      value: "custom"
    },
    {
      name: "Yesterday",
      value: "yesterday"
    },
    {
      name: "Today",
      value: "today"
    },
  ]

  customDate: string = null;

  constructor(
    private modalCtrl: ModalController,
    private cd: ChangeDetectorRef,
    private connectionService: ConnectionService,
    private alertService: AppAlertService
  ) { }

  ngOnInit() {
    
    if (this.connection){
      // For existing connections, set all values from the connection
      this.setValue = {
        quality: this.connection.quality || 'none',
        initiator: this.connection.initiator || 'none',
        medium: this.connection.medium || 'message',
        date: this.getDateSelection(String(this.connection.date) || null)
      }
      // Set custom date if connection has a date
      if (this.connection.date) {
        const date = new Date(this.connection.date);
        // Format date as YYYY-MM-DD for ion-datetime
        this.customDate = date.toISOString().split('T')[0];
      }
    } else {
      // For new connections, set default values
      this.setValue = {
        quality: 'none',
        initiator: 'none',
        medium: 'message',
        date: 'today'
      }
      this.customDate = new Date().toISOString().split('T')[0];
    }
    this.cd.detectChanges();
  }

  private getDateSelection(dateString: string | null): string {
    if (!dateString) return 'today';
    
    const connectionDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time parts for comparison
    connectionDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);

    if (connectionDate.getTime() === today.getTime()) {
      return 'today';
    } else if (connectionDate.getTime() === yesterday.getTime()) {
      return 'yesterday';
    } else {
      return 'custom';
    }
  }

  isFormValid(): boolean {
    return this.setValue.quality !== null &&
           this.setValue.initiator !== null &&
           this.setValue.medium !== null &&
           this.setValue.date !== null &&
           (this.setValue.date !== 'custom' || this.customDate !== null);
  }

  dismiss(){
  	this.modalCtrl.dismiss();
  }

  updateValue(value, type): void{
    if (type=='quality') {
      this.setValue.quality = value[0];
    }
    if (type=='initiator') {
      this.setValue.initiator = value[0];
    }
    if (type=='medium') {
      this.setValue.medium = value[0];
    }
    if (type=='date') {
      this.setValue.date = value[0];
      if (value[0] === 'custom' && !this.customDate) {
        this.customDate = new Date().toISOString().split('T')[0];
      }
    }
  }

  onCustomDateChange(event: any) {
    if (event?.detail?.value) {
      this.customDate = event.detail.value;
      this.setValue.date = 'custom';
    }
  }

  save(){
    if (!this.isFormValid()) {
      this.alertService.showErrorAlert("Please select all options before saving");
      return;
    }

    let savedConnection = {
      quality: this.setValue.quality,
      initiator: this.setValue.initiator,
      medium: this.setValue.medium,
      person: this.person,
      date: null
    }

    // Set the date based on selection
    if (this.setValue.date === 'today') {
      savedConnection.date = new Date().toISOString();
    } else if (this.setValue.date === 'yesterday') {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      savedConnection.date = yesterday.toISOString();
    } else if (this.setValue.date === 'custom' && this.customDate) {
      savedConnection.date = this.customDate;
    } else {
      savedConnection.date = new Date().toISOString();
    }

    if (this.connection){
      this.connectionService.editConnection(this.connection.documentId, savedConnection).then(()=>{
        this.alertService.showSuccessAlert("Saved Successfully")
        this.dismiss()
      }).catch((e)=>{
        this.alertService.showErrorAlert("Failed to Save: " + e?.message)
      })
    }
    else {
      this.connectionService.createConnection(savedConnection).then(()=>{
        this.alertService.showSuccessAlert("Saved Successfully")
        this.dismiss()
      }).catch((e)=>{
        this.alertService.showErrorAlert("Failed to Save: " + e?.message)
      })
    }
  }

  delete(){
    this.connectionService.deleteConnection(this.connection.documentId).then(()=>{
      this.alertService.showSuccessAlert("Deleted Successfully")
      this.dismiss()
    }).catch((e)=>{
      this.alertService.showErrorAlert("Failed to delete: " + e?.message)
    })
  }

  toggleCalendar(){
    this.accordion.toggle();
  }
}
